// Transformation (Pluto): the constellation surrounding Pluto is worth as
// much as the highest scoring other constellation (its step-3 score).
import { ranked } from '../shared/standings';
import { ownIndex } from '../shared/own';
import type { AlignmentDef } from '../types';

export const transformation: AlignmentDef = {
  id: 'transformation',
  planet: 'pluto',
  name: 'Transformation',
  text: () => 'The constellation that surrounds Pluto is worth as much as your highest scoring other constellation.',
  standing: (entries, ctx) => {
    const own = ownIndex(ctx, 'transformation');
    const best = ranked(entries).find((e) => e.index !== own);
    return own >= 0 && best ? [{ index: own, copyOf: best.index }] : [];
  },
};
